export default class BaseError extends Error {
  constructor(message, ...codes) {
    super(message)
    this.codes = codes
    this.name = this.constructor.name
  }
}
